import securityUtils from '../services/securityUtils';

export function usePortalClientBC(portalName: string): string | null {
  return securityUtils.getPortalClientBC(portalName || '') || null;
}
